import cookieConsent from '@/constants/cookieConsent.json'

const { cookieName, version } = cookieConsent
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60

const readCookies = () => (document.cookie ? document.cookie.split('; ') : [])

// Missing, malformed or older-version choices all count as "not decided yet".
export const readConsent = () => {
  const prefix = `${cookieName}=`
  const raw = readCookies().find((cookie) => cookie.startsWith(prefix))

  if (!raw) {
    return null
  }

  try {
    const consent = JSON.parse(decodeURIComponent(raw.slice(prefix.length)))
    return consent && typeof consent.analytics === 'boolean' && consent.version >= version ? consent : null
  } catch (e) {
    return null
  }
}

// Localhost and test hosts sit outside the brand's domain, so they keep a host-only cookie.
export const cookieDomainFor = (hostname, cookieDomain) => {
  const host = String(hostname || '').toLowerCase()

  return cookieDomain && (host === cookieDomain || host.endsWith(`.${cookieDomain}`)) ? cookieDomain : null
}

const writeCookie = (name, value, { maxAge, domain }) => {
  document.cookie = [
    `${name}=${value}`,
    'Path=/',
    `Max-Age=${maxAge}`,
    'SameSite=Lax',
    domain && `Domain=${domain}`,
    window.location.protocol === 'https:' && 'Secure'
  ].filter(Boolean).join('; ')
}

export const saveConsent = ({ analytics, domain }) => {
  const value = encodeURIComponent(JSON.stringify({ analytics, version, decidedAt: new Date().toISOString() }))

  writeCookie(cookieName, value, { maxAge: MAX_AGE_SECONDS, domain })
}

// Google Analytics puts its cookies on the parent domain, so expire both variants.
export const clearAnalyticsCookies = (domain) => {
  readCookies()
    .map((cookie) => cookie.split('=')[0])
    .filter((name) => name === '_ga' || name.startsWith('_ga_'))
    .forEach((name) => {
      writeCookie(name, '', { maxAge: 0 })
      if (domain) {
        writeCookie(name, '', { maxAge: 0, domain })
      }
    })
}
